import 'slick-carousel'

$(() => {

	const $frontpage = $('.yco-frontpage-slider');
	const $frontpagenav = $('.yco-frontpage-slider-nav');

	if (!$frontpage.length || !$frontpagenav.length) {
		return;
	}

	const optionsFrontpage = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 5000,
		asNavFor: '.yco-frontpage-slider-nav',
		responsive: [
			{
				breakpoint: 769,
				settings: "unslick"
			}
		]
	};
	const optionsFrontpagenav = {
		dots: false,
		arrows: false,
		infinite: true,
		asNavFor: '.yco-frontpage-slider',
		centerMode: true,
		focusOnSelect: true,
		swipe: false,
		swipeToSlide: false,
		touchMove: false,
		draggable: false,
		variableWidth: true,
		centerPadding: "0px",
		cssEase: 'ease',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					focusOnSelect: true,
					swipe: true,
					swipeToSlide: true,
					touchMove: true,
					draggable: true,
					speed: 500,
					cssEase: 'linear',
					dots: true,
				}
			}
		]
	};


	$frontpage.slick(optionsFrontpage);
	$frontpagenav.slick(optionsFrontpagenav);
});



// WEBPACK FOOTER //
// ./assets/scripts/frontpage_slider.js